import { Field, Form } from "react-final-form";
// 1. Updated Import to explicitly use SelectFinalForm
import { Input, RichTextField, SelectFinalForm } from "../../components/inputs";
import { useLocation, useNavigate } from "react-router-dom";

import { Button } from "../../components/button";
import { Grid } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";

const JOB_TYPES = [
  { label: "Full Time", value: "FULL_TIME" },
  { label: "Part Time", value: "PART_TIME" },
  { label: "Contract", value: "CONTRACT" },
  { label: "Freelance", value: "FREELANCE" },
  { label: "Internship", value: "INTERNSHIP" },
];

const JOB_STATUSES = [
  { label: "Open", value: "OPEN" },
  { label: "Closed", value: "CLOSED" },
  { label: "Archived", value: "ARCHIVED" },
];

export const CareersForm = ({ onFormSubmit, initialValues }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCancel = (resetForm) => {
    resetForm();
    if (location.pathname.includes("edit")) {
      navigate(-1, { replace: true });
    } else {
      navigate("/careers", { replace: true });
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.title) errors.title = "Required";
    if (!values.location) errors.location = "Required";
    if (!values.jobType) errors.jobType = "Required";
    if (!values.status) errors.status = "Required";
    if (!values.description) errors.description = "Required";
    return errors;
  };

  return (
    <Form
      onSubmit={onFormSubmit}
      initialValues={initialValues || { status: "OPEN", jobType: "FULL_TIME" }}
      validate={validate}
      render={({ handleSubmit, pristine, submitting, invalid, form }) => (
        <form onSubmit={handleSubmit}>
          <Grid col="l15">
            <div>
              <Field
                name="title"
                type="text"
                component={Input}
                label="Job Title"
                entity="&#10029;"
              />

              <Field
                name="location"
                type="text"
                component={Input}
                label="Location (e.g., Remote, Maryland)"
                entity="&#10029;"
              />

              <DropdownGrid>
                {/* 2. Seamlessly implement SelectFinalForm */}
                <Field
                  name="jobType"
                  component={SelectFinalForm}
                  label="Job Type"
                  entity="&#10029;"
                  options={JOB_TYPES}
                />

                <Field
                  name="status"
                  component={SelectFinalForm}
                  label="Status"
                  entity="&#10029;"
                  options={JOB_STATUSES}
                />
              </DropdownGrid>

              <Field
                name="description"
                component={RichTextField}
                label="Job Description"
                entity="&#10029;"
              />
            </div>
          </Grid>

          <ButtonFlex>
            <CancelText scale="small" onClick={() => handleCancel(form.reset)}>
              Cancel
            </CancelText>
            <Button
              type="submit"
              disabled={submitting || invalid}
              text={submitting ? "Saving..." : "Save Job"}
            />
          </ButtonFlex>
        </form>
      )}
    />
  );
};

// --- STYLED COMPONENTS ---
const DropdownGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ButtonFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
`;

const CancelText = styled(Text)`
  margin: 0;
  cursor: pointer;
  color: #6c757d;
  font-weight: 500;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: #dc3545;
    text-decoration: underline;
  }
`;
